import { render, staticRenderFns } from "./expenses-by-dos-report.vue?vue&type=template&id=2015a7f0"
import script from "./expenses-by-dos-report.vue?vue&type=script&lang=js"
export * from "./expenses-by-dos-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports